import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { fetchBlogs } from '../../../features/blogs/slice'
import { useInternationalization } from '../../../features/i18n/hook'
import { fetchEvents } from '../../../features/organization/events/slice'
import { fetchPrograms } from '../../../features/programs/slice'
import { fetchResources } from '../../../features/resources/slice'
import Map from './map-section-map'

const MapSection = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { translate } = useInternationalization()
  const data = useSelector(state => state.organization.data)
  const { total_cities, branch_total_cities } = useSelector(state => state.organization)
  const [totalProgram, setTotalProgram] = useState(0)
  const [totalEvent, setTotalEvent] = useState(0)
  const [totalResource, setTotalResource] = useState(0)
  const [totalBlog, setTotalBlog] = useState(0)

  const {
    // total_team,
    total_member,
    // total_activity,
    id
  } = data

  const totalCities = total_cities+branch_total_cities
  const totalCitiesRendered = isNaN(totalCities) ? 0 : totalCities

  useEffect(() => {
    dispatch(fetchPrograms({organization: id})).then(res => {
      if(res && res.payload && res.payload.count){
        setTotalProgram(res.payload.count)
      }
    })
    dispatch(fetchEvents({organization: id})).then(res => {
      if(res && res.payload && res.payload.count){
        setTotalEvent(res.payload.count)
      }
    })
    dispatch(fetchResources({organization: id})).then(res => {
      if(res && res.payload && res.payload.count){
        setTotalResource(res.payload.count)
      }
    })
    dispatch(fetchBlogs({organization: id})).then(res => {
      if(res && res.payload && res.payload.count){
        setTotalBlog(res.payload.count)
      }
    })
    // eslint-disable-next-line
  }, [id])

  return (
    <div className="mb-10 lg:mb-24">
      <div className="flex flex-wrap mx-auto w-5/6 lg:w-full lg:-mx-4 mb-3 lg:mb-8 justify-center">
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">
            {translate('CITY', 'plural')}
          </p>
          <p className="text-4xl lg:text-5xl">{String(totalCitiesRendered)}</p>
        </div>
        {/* <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">
            {translate('GENERAL', 'team')}
          </p>
          <p className="text-4xl lg:text-5xl">{total_team}</p>
        </div> */}
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">
            {translate('MEMBER', 'plural')}
          </p>
          <p className="text-4xl lg:text-5xl cursor-pointer" onClick={() => history.push(`/organization/${id}/member`)}>
            {total_member}
          </p>
        </div>
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">
            {translate('PROGRAM', 'plural')}
          </p>
          <p className="text-4xl lg:text-5xl cursor-pointer" onClick={() => history.push(`/organization/${id}/program`)}>
            {totalProgram}
          </p>
        </div>
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">
            {translate('EVENT', 'plural')}
          </p>
          <p className="text-4xl lg:text-5xl cursor-pointer" onClick={() => history.push(`/organization/${id}/event`)}>
            {totalEvent}
          </p>
        </div>
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">
            {translate('RESOURCE', 'plural')}
          </p>
          <p className="text-4xl lg:text-5xl cursor-pointer" onClick={() => history.push(`/organization/${id}/resource`)}>
            {totalResource}
          </p>
        </div>
        <div className="w-1/2 lg:w-1/4 px-2 lg:px-4 text-center mb-5">
          <p className="font-accent text-xs lg:text-sm font-bold uppercase">
            {translate('BLOG', 'plural')}
          </p>
          <p className="text-4xl lg:text-5xl cursor-pointer" onClick={() => history.push(`/organization/${id}/blog`)}>
            {totalBlog}
          </p>
        </div>
      </div>

      <Map />
    </div>
  )
}

export { MapSection }
